// Central Roller booking URL configuration.
// All "Book Now" / "Reserve Your Experience" buttons across the site
// deep-link to this Roller checkout via openRollerBooking().

const ROLLER_BASE = 'https://ecom.roller.app/thebr8kroom/booknow/en-us/products';

/** Returns today's date formatted as YYYY-MM-DD for the Roller ?date= param. */
const todayISO = () => {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

/** Full Roller booking URL for today. Accepts optional overrides. */
export const getRollerBookingUrl = ({ date } = {}) => {
  const params = new URLSearchParams({ date: date || todayISO() });
  return `${ROLLER_BASE}?${params.toString()}`;
};

/** Opens the Roller checkout in a new tab. Use for every Book Now click. */
export const openRollerBooking = (opts = {}) => {
  const url = getRollerBookingUrl(opts);
  window.open(url, '_blank', 'noopener,noreferrer');
};
